import { render, staticRenderFns } from "./MIVBError.vue?vue&type=template&id=d8bcabee&"
import script from "./MIVBError.vue?vue&type=script&lang=js&"
export * from "./MIVBError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports